import { getField, updateField } from "vuex-map-fields";
import Repository from "@/repository";

const VEHICLE_RENEWAL_API = "/vehicleRenewal";

// ----------------------- STATE ------------------------- //
const state = {
  vehicle_renewal_data: [],
  currentIndex: -1
};

// ----------------------- GETTERS ----------------------- //
const getters = {
  getVehicle_renewal: state =>
    getField(state.vehicle_renewal_data[state.currentIndex]),

  getCurrentVehicle_renewal: state => {
    return state.vehicle_renewal_data[state.currentIndex];
  },
  getVehicleRenewalReminder: state => vehicleID => {
    return state.vehicle_renewal_data.filter(item => {
      let index = item.vehicles_id.findIndex(theID => theID == vehicleID);
      return index != -1;
    });
  },

  getOverdue: state => vehicleID => {
    //todo: fish up the Overdue
    let vehicleReminders = state.vehicle_renewal_data.filter(item => {
      let index = item.vehicles_id.findIndex(theID => theID == vehicleID);
      return index != -1;
    });
    return vehicleReminders.length;
  },

  getDueSoon: state => vehicleID => {
    //todo: fish up the Due Soon
    let vehicleReminders = state.vehicle_renewal_data.filter(item => {
      let index = item.vehicles_id.findIndex(theID => theID == vehicleID);
      return index != -1;
    });
    return vehicleReminders.length;
  }
};

// ----------------------- MUTATIONS -------------------- //
const mutations = {
  updateVehicle_renewal(state, payload) {
    updateField(state.vehicle_renewal_data[state.currentIndex], payload);
  },

  setCurrentIndexByID(state, theID) {
    state.currentIndex = state.vehicle_renewal_data.findIndex(
      vehicle_renewal => vehicle_renewal.id == theID
    );
  },

  loadAllVehicle_renewals(state, payload) {
    state.vehicle_renewal_data = payload.data;
    state.currentIndex = 0;
  },

  addVehicle_renewal(state, payload) {
    state.vehicle_renewal_data.push(payload.data);
    state.currentIndex = state.vehicle_renewal_data.length - 1;
  },

  saveVehicle_renewal(state, payload) {
    state.vehicle_renewal_data[state.currentIndex] = payload.data;
  },

  fetchVehicle_renewal(state, payload) {
    if (state.currentIndex == -1) {
      state.vehicle_renewal_data.push(payload.data);
      state.currentIndex = 0;
    } else {
      state.vehicle_renewal_data[state.currentIndex] = payload.data;
    }
  },

  fetchByVehicleIDVehicle_renewal(state, payload) {
    if (payload.data.length > 0) {
      state.vehicle_renewal_data = payload.data;
      state.currentIndex = -1;
    }
  },

  deleteVehicle_renewal(state, payload) {
    state.currentIndex = state.vehicle_renewal_data.findIndex(
      vehicle_renewal => vehicle_renewal.id == payload.data.id
    );
    state.vehicle_renewal_data.splice(state.currentIndex, 1);
  },

  cleanUpStringToNumbers(state) {
    let item = state.vehicle_renewal_data[state.currentIndex];
    item.start_odometer = parseInt(item.start_odometer);
    item.interval_odometer = parseInt(item.interval_odometer);
    item.due_odometer = parseInt(item.due_odometer);
  },
  reset(state) {
    state.vehicle_renewal_data = []
    state.currentIndex = -1
  }
};

// ----------------------- ACTIONS -------------------- //
const actions = {
  async loadAllVehicle_renewals({ commit }) {
    try {
      commit(
        "loadAllVehicle_renewals",
        await Repository.get(`${VEHICLE_RENEWAL_API}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async addVehicle_renewal({ commit }) {
    await Repository.get(`${VEHICLE_RENEWAL_API}/new`)
      .then(response => {
        commit("addVehicle_renewal", response);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async saveVehicle_renewal({ state, commit }) {
    try {
      commit("cleanUpStringToNumbers");
      commit(
        "saveVehicle_renewal",
        await Repository.post(
          `${VEHICLE_RENEWAL_API}`,
          state.vehicle_renewal_data[state.currentIndex]
        )
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchVehicle_renewal({ commit }, payloadID) {
    try {
      commit(
        "fetchVehicle_renewal",
        await Repository.get(`${VEHICLE_RENEWAL_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async fetchByVehicleIDVehicle_renewal({ commit }, payloadID) {
    try {
      commit(
        "fetchByVehicleIDVehicle_renewal",
        await Repository.get(`${VEHICLE_RENEWAL_API}/vehicle/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async deleteVehicle_renewal({ commit }, payloadID) {
    try {
      commit(
        "deleteVehicle_renewal",
        await Repository.delete(`${VEHICLE_RENEWAL_API}/${payloadID}`)
      );
    } catch (error) {
      console.log(error);
    }
  },

  async searchVehicle_renewals({ commit }, searchTerm) {
    try {
      commit(
        "loadAllVehicle_renewals",
        await Repository.get(`${VEHICLE_RENEWAL_API}/search?q=${searchTerm}`)
      );
    } catch (error) {
      console.log(error);
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
